import RichText from '@/components/RichText';
import { cls } from '@/utils/cls';
import styles from './FooterV1.module.scss';
import type { FooterV1Props } from './types';
export default function FooterV1({
  bottomPaddingValue = '1.25rem',
  extendStyles,
  footerBackgroundColor,
  footerTextColor,
  isLightMode = false,
  copy,
  links
}: FooterV1Props) {
  const _className = cls(styles.root, isLightMode ? styles.light : styles.dark, extendStyles);
  const _customStyles = {
    backgroundColor: footerBackgroundColor || 'var(--color-background-grey)',
    color: footerTextColor || 'var(--color-white)'
  };
  return <footer className={_className} style={{
    ...(!isLightMode ? _customStyles : undefined),
    paddingBottom: bottomPaddingValue
  }} data-sentry-component="FooterV1" data-sentry-source-file="FooterV1.tsx">
			<RichText text={copy} className={styles.copy} data-sentry-element="RichText" data-sentry-source-file="FooterV1.tsx" />
			<nav className={styles.links}>
				{links.map((e, i) => <a key={`footer-link-${i}`} href={e.linkDestination} rel="noopener noreferrer" target="_blank">
						{e.linkText}
					</a>)}
			</nav>
		</footer>;
}